import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { BuildingIcon } from '@repo/ui/icons'
import { useMutation, useQuery } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createCse, generateCodePartner } from '../../api/cse/cse'
import UserNavBar from '../../components/elements/nav-bar'
import CseForm from '../../components/pages/cse/cse-form'
import { mapCseInputToRequest } from '../../components/pages/cse/utils'
import { Paths } from '../../lib/constants/path'
import { BillingTypeEnum } from '../../lib/types/enums/cse/billing-type.enum'
import { CseInput } from '../../lib/types/models/cse/cse'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const CseCreatePage = () => {
  const { navigate, back } = useNavigator()

  const createCseMutation = useMutation({
    mutationFn: createCse,
    onError: showAxiosError,
    onSuccess: () => {
      toast.success('CSE créé avec succès')
    }
  })

  const { data } = useQuery({
    queryKey: ['generate-partner-code'],
    queryFn: () => generateCodePartner(),
    staleTime: Infinity
  })

  const defaultValues: Partial<CseInput> = {
    code: data?.code,
    billingType: BillingTypeEnum.FCSE,
    offerCancellationInsurance: false,
    cancellationInsuranceOffered: false,
    cancellationInsuranceMandatory: false,
    repatriationInsuranceMandatory: false,
    repatriationInsuranceOffered: false,
    localTransportCostsOffered: false
  }

  if (!data) return null

  return (
    <div>
      <UserNavBar title={'Créer un CSE'} icon={BuildingIcon} />
      <div className={'h-4'} />

      <Box>
        <CseForm
          defaultValues={defaultValues}
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await createCseMutation.mutateAsync(mapCseInputToRequest(values))
              navigate(Paths.CSE_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back()
          })}
        />
      </Box>
    </div>
  )
}

export default CseCreatePage
